// extracted by mini-css-extract-plugin
module.exports = {"container":"TabsNavigation_container_aJt0t","link":"TabsNavigation_link_2DuvT","active":"TabsNavigation_active_VAwet"};